<template>
	<section class="small-12 columns categoryTitle">
        <h1 class="small-12 flex">
            Category Title
        </h1>
        <p class="small-12">
            Sharing tips, perspectives, and insights to help you tackle the burden of debt.
        </p>
    </section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'BlogCategoryTitle',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>